import * as angular from "angular";
import {IController, IOnChangesObject} from "angular";
import {SplitService} from "../../services/split-service.service";
import * as _ from "lodash";

export class BringozCapacityComponent implements IController {
  weight: any;
  volume: any;
  packages: any;
  pallets: any;
  totalWeight: any;
  totalVolume: any;
  totalPackages: any;
  totalPallets: any;
  spots: any;
  totalSpots: any;
  showPackages: string;
  isLayoutRow: any;

  public weightUnit: any;
  public volumeUnit: any;
  public labelsMap: any;

  constructor(private splitService: SplitService) {
    this.weightUnit = splitService.getWeightUnit();
    this.volumeUnit = splitService.getVolumeUnit();

    this.labelsMap = {};
    const siteLabels = this.splitService.getSiteLabels();
    _.forEach(siteLabels, (l) => {
      this.labelsMap[l.name] = l;
    })
  }

}

angular
  .module('bringoz.admin.commons')
  .component('bringozCapacity', {
    bindings: {
      weight: '<',
      volume: '<',
      packages: '<',
      pallets: '<',
      totalWeight: '<',
      totalVolume: '<',
      totalPackages: '<',
      totalPallets: '<',
      spots: '<',
      totalSpots: '<',
      showPackages: '@?',
      isLayoutRow: '<?'
    },
    templateUrl: 'app/modules/commons/components/bringoz-capacity/bringoz-capacity.html',
    controller: BringozCapacityComponent
  });
